import { DATE_WITH_TIME_FORMAT } from '@utils/constants';
import dayjs from 'dayjs';

type Format = 'DD.MM.YYYY' | 'DD.MM.YYYY HH:mm' | 'DD.MM.YYYY HH:mm:ss' | (string & {});

export const timeStampToDate = ({
  date,
  timeStamp,
  format
}: {
  date: string;
  timeStamp?: number | null;
  format?: Format;
}) =>
  timeStamp
    ? dayjs
      .unix(timeStamp)
      .tz()
      .format(format || DATE_WITH_TIME_FORMAT)
    : date;

export const dateToTimeStamp = ({
  date,
  format,
  start,
  end
}: { date?: string; format?: Format } & (
  | { start?: dayjs.OpUnitType; end?: never }
  | { end?: dayjs.OpUnitType; start?: never }
)) => {
  if (date) {
    if (start) {
      return Number(
        dayjs(date, format || DATE_WITH_TIME_FORMAT)
          .tz(undefined, true)
          .startOf(start)
          .unix()
      );
    }
    if (end) {
      return Number(
        dayjs(date, format || DATE_WITH_TIME_FORMAT)
          .tz(undefined, true)
          .endOf(end)
          .unix()
      );
    }
    return Number(
      dayjs(date, format || DATE_WITH_TIME_FORMAT)
        .tz(undefined, true)
        .unix()
    );
  }
  return undefined;
};
